import Attributions from './Attributions'
export default Attributions
